import { render } from "./add-car-modal.vue?vue&type=template&id=0067ce0e"
import script from "./add-car-modal.vue?vue&type=script&lang=js"
export * from "./add-car-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__